module.exports = __webpack_public_path__ + "static/happy_01-130dcfecee9959976d2a1637b612d7f5.jpeg";